'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = _react2['default'].createClass({
    displayName: 'SEO Body Section',

    render: function render() {
        return _react2['default'].createElement(
            'div',
            { className: 'm-marketing-page row' },
            _react2['default'].createElement(
                'div',
                { className: 'columns small-12' },
                this.props.children
            )
        );
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/common/body-section.jsx
 ** module id = 1211
 ** module chunks = 0
 **/